import React, { Component } from 'react';
import { FormDataObject } from './FormDataObject.js';

class Form extends Component {
    constructor() {
        super();
        this.postData = this.postData.bind(this);

        this.state = {
            loaderDisplay: "none",
            takanon: false,
            name: "",
            phone: "",
            email: "",
            association: "",
            occupation: "",
            description: ""
        }
    }

    setLoader(display) {
        this.setState({
            loaderDisplay: display
        });
    }

    async postData() {
        //let that = this;
        if (!this.state.takanon) { alert("יש לאשר את התקנון"); return; }
        try {
            var formData = new FormDataObject(this.state.name, this.state.phone,
                this.state.email, this.state.association,
                this.state.occupation, this.state.description);
        }
        catch (e) {
            alert(e);
            return;
        }
        this.setLoader("block");

        let result = await this.getData(formData);
        this.setLoader("none");
        this.setState({
            name: "",
            phone: "",
            email: "",
            association: "",
            occupation: "",
            description: ""
        });
        this.props.onPostFinished(result);
    }

    getData(formData){
        return fetch('//z.ynet.co.il/mLong/commerce/2018/poalim70years/api/home/Save', {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(formData)
        }).then(response => response.json())
    }

    render() {
        return (
            <div className="form">
                <div id="loadbar" style={{ "display": this.state.loaderDisplay }}><div className="loaderarea"><div className="loader"></div></div></div>
                <h2>זאת העמותה שלי</h2>
                <div className="desc">"ידיעות אחרונות", ynet ובנק הפועלים מזמינים אתכם לספר על עמותה, ארגון או מיזם חברתי שהייתם שותפים לו, או כזה שהכרתם והרשים אתכם. ספרו לנו כיצד הוא תורם למדינה שלנו בכלל וכיצד הוא השפיע עליכם בפרט.</div>
                <div className="tofes">
                    <input type="text" maxLength="250" value={this.state.name} onChange={(event) => this.setState({ name: event.target.value })} className="inputs" id="name" placeholder="שם מלא" />
                    <input type="tel" maxLength="50" value={this.state.phone} onChange={(event) => this.setState({ phone: event.target.value })} className="inputs" id="phone" placeholder="טלפון" />
                    <input type="email" maxLength="150" value={this.state.email} onChange={(event) => this.setState({ email: event.target.value })} className="inputs" id="email" placeholder='דוא"ל' />
                    <input type="text" maxLength="250" value={this.state.association} onChange={(event) => this.setState({ association: event.target.value })} className="inputs" id="association" placeholder="שם העמותה" />
                    <input type="text" maxLength="250" value={this.state.occupation} onChange={(event) => this.setState({ occupation: event.target.value })} className="inputs" id="occupation" placeholder="תחום עיסוקה" />
                </div>
                <div>
                    <textarea id="ccupation" maxLength="4000" value={this.state.description} onChange={(event) => this.setState({ description: event.target.value })} placeholder="ספרו על המיזם ועל הקשר שלכם אליו"></textarea>
                </div>
                <div className="tofes-bottom">
                    <div className="right-side">
                        <input type="checkbox" name="takanon" id="takanon" checked={this.state.takanon} onChange={(event) => this.setState({ takanon: !this.state.takanon })} />
                        <label htmlFor="takanon">
                            <div>
                                אישור
                        <a href="http://z.ynet.co.il/short/commerce/2018/poalim70years/files/tak.html" title="" target="_blank">תקנון</a>
                            </div>
                        </label>
                    </div>
                    <div className="left-side">
                        <button id="submit" onClick={this.postData}></button>
                    </div>
                </div>
            </div>
        );
    }
}


export default Form;


// WEBPACK FOOTER //
// ./src/Components/Main/Form.js